import { render } from "./AppTask.vue?vue&type=template&id=281187d6&scoped=true"
import script from "./AppTask.vue?vue&type=script&lang=js"
export * from "./AppTask.vue?vue&type=script&lang=js"

import "./AppTask.vue?vue&type=style&index=0&id=281187d6&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\astac\\OneDrive\\Рабочий стол\\twodolist\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-281187d6"]])

export default __exports__